var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.22,
    height: 34.198,
    viewBox: "0 0 51.22 34.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.497,
    y1: 1,
    x2: 0.497,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b537d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76709a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efb535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.51,
    y1: 0.998,
    x2: 0.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76719a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928fb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    "data-name": "Path 8196",
    d: "M40.41,16.4h-.23a7.52,7.52,0,0,0,.18-1.59,7.28,7.28,0,0,0-7.28-7.28h0a7.26,7.26,0,0,0-1.82.24A11.59,11.59,0,0,0,8.78,10.39H8.71A8.71,8.71,0,0,0,0,19.1H0a8.71,8.71,0,0,0,8.71,8.71h31.7a5.71,5.71,0,1,0,0-11.41Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_721",
    "data-name": "Ellipse 721",
    cx: 15.38,
    cy: 15.38,
    r: 15.38,
    transform: "translate(20.46 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M14.43,22.2A9.56,9.56,0,0,1,24,12.63h0a9.56,9.56,0,0,1,9.4,7.812l.17,0a6.85,6.85,0,0,1,.1,13.7H14.43a6,6,0,1,1,0-11.93Z",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudy);
export default __webpack_public_path__ + "static/media/PartlyCloudy.471fa788497b5a65073671d860ee74bd.svg";
export { ForwardRef as ReactComponent };